import { render, staticRenderFns } from "./StudentGoalHeader.vue?vue&type=template&id=3de57d1c&scoped=true&lang=pug&"
import script from "./StudentGoalHeader.vue?vue&type=script&lang=ts&"
export * from "./StudentGoalHeader.vue?vue&type=script&lang=ts&"
import style0 from "./StudentGoalHeader.vue?vue&type=style&index=0&id=3de57d1c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de57d1c",
  null
  
)

export default component.exports